import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import { getMessages } from '../constants'
import { OrderedListNumber, StepBox, StepLabel, StepLabelDesc } from '../style'
import Button from '@components/Button'
import Spacer from '@berlitz/spacer'
import { useFMIBulkSelectInstructors } from '../SelectInstructors/useSelectInstructors'
import { FMIStudentProfileContext, useFave } from '../../context'
import { orderBy, uniqBy } from 'lodash'
import { useDispatch } from 'react-redux'
import {
  updateFMIBulkFormInstructorTypes,
  updateFMIBulkFormInstructors,
  updateFMIBulkFormSelectedDate,
} from '@redux/actions/fmiBulkForm'
import { useRouter } from 'next/router'
import { useFMIBulkForm } from '../Form/useFMIBulkForm'

const ViewCalendars: React.FC = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const router = useRouter()
  const { faveInstructors = [], rawInstructors = [], programId } = useFave()
  const { isButtonsDisabled, setIsButtonsDisabled, fetchedInstructors = [], values } = useFMIBulkForm()
  const { selectedInstructorIds } = useFMIBulkSelectInstructors()
  const { baseRoute, getRouteParams, isBulkPage } = useContext(FMIStudentProfileContext)
  const messages = getMessages()

  if (!selectedInstructorIds.length) {
    return (
      <div style={{ visibility: 'hidden' }}>
        <StepBox>
          <StepBox className="step3">
            <OrderedListNumber>3</OrderedListNumber>
            <StepLabel>
              <div>{intl.formatMessage(messages.step3Label)}</div>

              <div className="actions">
                <StepLabelDesc>{intl.formatMessage(messages.step3LabelDesc)}</StepLabelDesc>

                <Button narrow>{intl.formatMessage(messages.step3Label)}</Button>
              </div>
            </StepLabel>
          </StepBox>
        </StepBox>

        <Spacer size="lg" />
      </div>
    )
  }

  return (
    <>
      <StepBox>
        <StepBox className="step3">
          <OrderedListNumber>3</OrderedListNumber>
          <StepLabel>
            <div>{intl.formatMessage(messages.step3Label)}</div>

            <div className="actions">
              <StepLabelDesc className="desc-wrapper">
                <span className="desc">{intl.formatMessage(messages.step3LabelDesc)}</span>

                <Button
                  narrow
                  disabled={isButtonsDisabled}
                  loading={isButtonsDisabled}
                  loadingText={intl.formatMessage(messages.redirecting)}
                  onClick={() => {
                    setIsButtonsDisabled(true)

                    const favouriteInstructors = orderBy(faveInstructors, ['Name'], 'asc')
                    const pastInstructors = orderBy(
                      rawInstructors?.filter(({ IsPreferred, IsPrevious }) => !IsPreferred && IsPrevious),
                      ['Name'],
                      'asc'
                    )
                    const filteredInstructors = orderBy(fetchedInstructors, 'Ranking', 'asc')
                      ?.filter(({ InstructorId }) => selectedInstructorIds?.includes(InstructorId))
                      ?.filter(
                        ({ InstructorId: fetchedId }) =>
                          !faveInstructors?.some(({ InstructorId }) => InstructorId === fetchedId)
                      )
                      ?.filter(
                        ({ InstructorId: fetchedId }) =>
                          !pastInstructors?.some(({ InstructorId }) => InstructorId === fetchedId)
                      )

                    const mostAvailableInstructors = rawInstructors?.filter(({ InstructorId: rawId }) =>
                      filteredInstructors?.some(({ InstructorId: filterId }) => filterId === rawId)
                    )
                    const FMIBulkFormInstructors = uniqBy(
                      [...favouriteInstructors, ...pastInstructors, ...mostAvailableInstructors],
                      'InstructorId'
                    )

                    if (FMIBulkFormInstructors.length) {
                      dispatch(updateFMIBulkFormInstructors(FMIBulkFormInstructors))
                      dispatch(
                        updateFMIBulkFormInstructorTypes(
                          favouriteInstructors,
                          pastInstructors,
                          mostAvailableInstructors
                        )
                      )
                      dispatch(updateFMIBulkFormSelectedDate(values?.PreferredStartDate || ''))

                      const firstInstructor = FMIBulkFormInstructors[0]
                      router.push(
                        `${baseRoute}/availability${isBulkPage ? '/bulk' : ''}?instructorId=${
                          firstInstructor.InstructorId
                        }&programId=${programId}&${getRouteParams(['instructorId', 'programId'])}`
                      )
                    }
                  }}
                >
                  {intl.formatMessage(messages.step3Label)}
                </Button>
              </StepLabelDesc>
            </div>
          </StepLabel>
        </StepBox>
      </StepBox>

      <Spacer size="lg" />
    </>
  )
}

export default ViewCalendars
